// Major financial aid and bursary institutions in South Africa
export const financialInstitutions = [
  {
    name: 'NSFAS (National Student Financial Aid Scheme)',
    type: 'Financial Aid',
    applyUrl: 'https://my.nsfas.org.za/'
  },
  {
    name: 'Funza Lushaka Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.funzalushaka.doe.gov.za/'
  },
  {
    name: 'Allan Gray Orbis Foundation Fellowship',
    type: 'Bursary/Scholarship',
    applyUrl: 'https://www.allangrayorbis.org/'
  },
  {
    name: 'Department of Health Bursaries',
    type: 'Bursary',
    applyUrl: 'https://www.gov.za/about-government/government-programmes/health-bursaries'
  },
  {
    name: 'Sasol Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.sasolbursaries.com/'
  },
  {
    name: 'Shoprite Bursary',
    type: 'Bursary',
    applyUrl: 'https://bursaries.shoprite.co.za/'
  },
  {
    name: 'Old Mutual Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.oldmutual.co.za/about-us/bursaries/'
  },
  {
    name: 'Standard Bank Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.standardbank.com/southafrica/personal/about-us/careers/graduate-opportunities/bursaries'
  },
  {
    name: 'FNB Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.fnb.co.za/about-fnb/careers/bursaries.html'
  },
  {
    name: 'Capitec Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.capitecbank.co.za/about-us/careers/career-opportunities/bursaries/'
  }
];
